import { render, staticRenderFns } from "./ssjk_pm.vue?vue&type=template&id=004addba&scoped=true&"
import script from "./ssjk_pm.vue?vue&type=script&lang=js&"
export * from "./ssjk_pm.vue?vue&type=script&lang=js&"
import style0 from "./ssjk_pm.vue?vue&type=style&index=0&id=004addba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004addba",
  null
  
)

export default component.exports